/** Dieselben Suffixe, die auth-js in `_removeSession` löscht. */
export const AUTH_SESSION_SUFFIXES = ["", "-code-verifier", "-user"] as const;

export type AuthSessionStorage = {
  getItem?: (key: string) => unknown;
  removeItem: (key: string) => unknown;
};

/**
 * Dieselbe Ableitung wie `@supabase/supabase-js` (`sb-<ref>-auth-token`).
 * Die App setzt keinen eigenen storageKey.
 */
export function authStorageKeyFromSupabaseUrl(url: string): string {
  const ref = new URL(url).hostname.split(".")[0];
  if (!ref) throw new Error("Supabase-URL ohne Projekt-Ref");
  return `sb-${ref}-auth-token`;
}

export async function removePersistedAuthSession(
  storage: AuthSessionStorage,
  storageKey: string | null,
): Promise<void> {
  if (!storageKey) return;
  for (const suffix of AUTH_SESSION_SUFFIXES) {
    const key = `${storageKey}${suffix}`;
    try {
      await storage.removeItem(key);
    } catch (err: unknown) {
      console.error(
        "Auth session key remove failed",
        key,
        err instanceof Error ? err.message : err,
      );
    }
  }
}
